import React, { FC } from "react";
import { FormControl, RadioGroup, InputLabel, SxProps } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { BpRadio, Loading, MyFormControlLabel } from "../..";

interface IRadioGroupControllerProps {
  id?: string;
  name: string;
  label: string;
  control: Control<any>;
  fullWidth?: boolean;
  defaultValue?: any;
  options: { value: string, label: string | React.ReactNode, disabled?: boolean }[];
  sx?: any;
  sxControl?: SxProps;
  variant?: "default" | "card" | "vertical" | "block";
  isLoading?: boolean;
  defaultChecked: boolean
  onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioGroupController: FC<IRadioGroupControllerProps> = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  defaultValue,
  options,
  sx,
  sxControl,
  variant = "card",
  isLoading = false,
  onChange,
  defaultChecked,
}) => {
  const fieldId = id || name;

  return (
    <FormControl fullWidth={fullWidth}>
      {label &&
        <InputLabel sx={{ position: "relative", marginBottom: "6px" }}>{label}</InputLabel>
      }
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) =>
          <>
            <RadioGroup
              id={fieldId}
              aria-labelledby={fieldId}
              {...field}
              name={name}
              defaultValue={field.value || defaultValue}
              sx={sx}
              onChange={(evt) => {
                field.onChange(evt);
                onChange && onChange(evt);
              }}
            >
              {options?.map((option) => (
                <MyFormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<BpRadio />}
                  label={option.label}
                  disabled={!!option.disabled}
                  variant={variant}
                  sx={sxControl}
                  defaultChecked={defaultChecked}
                  className={!!fieldState.error ? "error" : ""}
                />
              ))}
            </RadioGroup>

            {isLoading ? <Loading size={20} /> : null}
          </>
        }
      />
    </FormControl>
  );
};

export default RadioGroupController;
